// extracted by mini-css-extract-plugin
export default {"slider":"slider_slider__YoPVF","responsive_image":"slider_responsive_image__AZmEB","warn":"slider_warn__XXyAN","hover":"slider_hover__x--AC"};